export async function signIn(provider, data, config) {
    if (data) {
        const path = `/api/auth/callback/${provider}`;
        const res = await fetch(path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return await res.json();
    }
    let redirectUrl;
    if (config?.redirectUrl) {
        redirectUrl = config.redirectUrl;
    }
    else {
        let $val;
        if ($val) {
            redirectUrl = `${$val.host}${$val.path}?${$val.query}`;
        }
    }
    const queryData = {
        redirect: redirectUrl ?? "/",
    };
    const query = new URLSearchParams(queryData);
    const path = `/api/auth/login/${provider}?${query}`;
    return path;
}
